import sandiskIcon from "../../assets/icons/SanDisk.png";
import pokemonIcon from "../../assets/icons/Pokemon.png";
import goldIcon from "../../assets/icons/Gold.png";

/**
 * Build share-card payload from live Your PNL tab data.
 */
export function buildPnlSharePayload({
  liveUser,
  userRank,
  profileDisplayLabel,
  profileSrc,
  profileImageEl,
  profileImagePreloaded,
}) {
  const points = Number(userRank?.points);
  const rawPct = Number(
    userRank?.percentile ?? userRank?.topPercent ?? userRank?.top_percent
  );
  const topPercent =
    Number.isFinite(rawPct) && rawPct > 0 ? Math.min(100, Math.round(rawPct)) : 5;
  const pts = Number.isFinite(points) ? Math.max(0, Math.round(points)) : 0;

  return {
    username: profileDisplayLabel,
    topPercent,
    points: pts,
    pnlEth: Number(liveUser?.totalRevenue) || 0,
    roiPct: Number(liveUser?.roi) || 0,
    profileSrc: profileSrc || null,
    profileImageEl: profileImageEl || null,
    profileImagePreloaded: profileImagePreloaded || null,
    statsCaption: "Peak ROI If You Bought These Instead",
    metrics: [
      {
        brandKey: "sandisk",
        brandIcon: sandiskIcon,
        value: Number(userRank?.Sandisk) || 0,
        inlineLabel: null,
      },
      {
        brandKey: "pokemon",
        brandIcon: pokemonIcon,
        value: Number(userRank?.Pokemon) || 0,
        inlineLabel: "Cards:",
      },
      {
        brandKey: "gold",
        brandIcon: goldIcon,
        value: Number(userRank?.Gold) || 0,
        inlineLabel: "Gold:",
      },
    ],
  };
}
